<template>
  <div class="web-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item)  in levelList" :key="item.path" v-if="item.meta.title" :to="{path:item.path}">
        {{item.meta.title}}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
  export default {
    name: 'cms-breadcrumb',
    data() {
      return {
        levelList: null
      }
    },
    watch: {
      $route(to, from) {
        this.getBreadcrumb();
      }
    },
    mounted() {
      this.getBreadcrumb();
    },
    methods: {
      // 生成面包屑
      getBreadcrumb() {
        let matched = this.$route.matched.filter(item => item.name);
        this.levelList = matched;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue